/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import navigationBarMobileStyle from "./navigationBarMobileStyle";
import Toolbar from "@mui/material/Toolbar";
import { withScroll } from "../../../../services/withScroll";
import { AppBar } from "@mui/material";
import Grid from "@mui/material/Grid";
import Logo from "../../Logo/Logo";
import NavigationMenuMobile from "./NavigationMenuMobile";
import { useCustomer } from "../../../../provider/Customer/CustomerProvider";
import MessageNotifications from "../MessageNotifications";
import { NavigationBarProps } from "../NavigationBar";

const NavigationBarMobile = ({ scrollPosition = 0, minimal, clickableLogo, hideMainNavigation = false }: NavigationBarProps) => {
  const scrolledStyle = scrollPosition > 1;
  const { isLoggedIn } = useCustomer();

  return (
    <AppBar position={"fixed"} color={scrolledStyle ? "inherit" : "transparent"} elevation={scrolledStyle ? 4 : 0} aria-label={"Hauptnavigation"} role={"navigation"}>
      <Toolbar>
        <Grid
          container
          columnSpacing={5}
          sx={[{
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }, navigationBarMobileStyle.navigationContainer]}>
          <Grid>
            <Logo target={isLoggedIn ? "/servicewelt" : "/"} isClickable={clickableLogo} />
          </Grid>
          {!minimal && (
            <Grid>
              {isLoggedIn ? <MessageNotifications /> : null}
              <NavigationMenuMobile clickableLogo={clickableLogo} hideMainNavigation={hideMainNavigation} />
            </Grid>
          )}
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default withScroll(NavigationBarMobile);
